import { render, staticRenderFns } from "./submissions-modal.vue?vue&type=template&id=f2d8a5f4&scoped=true&"
import script from "./submissions-modal.vue?vue&type=script&lang=ts&"
export * from "./submissions-modal.vue?vue&type=script&lang=ts&"
import style0 from "./submissions-modal.vue?vue&type=style&index=0&id=f2d8a5f4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d8a5f4",
  null
  
)

export default component.exports